import { render, staticRenderFns } from "./VerificationSummary.vue?vue&type=template&id=36541a3c&scoped=true&"
import script from "./VerificationSummary.vue?vue&type=script&lang=js&"
export * from "./VerificationSummary.vue?vue&type=script&lang=js&"
import style0 from "./VerificationSummary.vue?vue&type=style&index=0&id=36541a3c&scoped=true&lang=css&"
import style1 from "./VerificationSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36541a3c",
  null
  
)

export default component.exports